<div class="new-enquiry-page">
  <!-- Header -->
  <header class="page-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="router.navigate(['/dashboard'])">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">Enquiry Note Details</h1>
    </div>
  </header>

  <div class="page-content position-relative">
    
    <div class="text-center mt-5" *ngIf="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Loading Details...</p>
    </div>

    <div class="detail-container" *ngIf="!isLoading && detail">

      <!-- Status & ID Card -->
      <!-- <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0;">
        <div class="card-body p-4 d-flex justify-content-between align-items-center">
          <div>
            <h6 class="text-muted mb-1 text-uppercase small fw-bold">Note ID</h6>
            <h4 class="mb-0 fw-bold">#{{ detail.enquiryNotesId || noteId }}</h4>
          </div>
          <div class="text-end">
            <span class="badge bg-primary fs-6 px-3 py-2 rounded-pill shadow-sm">
              {{ detail.statusDescription || 'Enquiry Placed' }}
            </span>
          </div>
        </div>
      </div> -->

      <!-- Vehicle Info & Text Notes -->
      <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0;" *ngIf="detail.veh_no || detail.text">
        <div class="card-body p-4">
          <h5 class="fw-bold mb-3"><i class="fas fa-car me-2 text-primary"></i>Vehicle Information</h5>
          
          <div class="mb-3" *ngIf="detail.veh_no">
            <p class="fs-5 mb-0 p-3 rounded border" style="background-color: #ffffff;">{{ detail.veh_no }}</p>
          </div>

          <div *ngIf="detail.text">
            <p class="mb-0 fs-6 bg-light p-3 rounded border" style="background-color: #ffffff;">{{ detail.text }}</p>
          </div>
        </div>
      </div>

      <!-- Voice Recording Section -->
      <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #d1f0e8;" *ngIf="detail.voice_url">
        <div class="card-body p-4 text-center rounded" style="background-color: #e8f5f2;">
          <h5 class="fw-bold mb-3"><i class="fas fa-microphone-alt me-2 text-success"></i>Voice Note</h5>
          <div class="d-flex justify-content-center mt-3">
            <button type="button" class="btn btn-success rounded-circle shadow-sm d-flex justify-content-center align-items-center border-0" 
                    style="width: 70px; height: 70px; background: linear-gradient(135deg, #28a745 0%, #20c997 100%);" 
                    (click)="playAudio(detail.voice_url)">
              <i class="fas fs-2 text-white" [ngClass]="isPlayingAudio ? 'fa-pause' : 'fa-play'"></i>
            </button>
          </div>
          <p class="mt-3 text-success small fw-bold text-uppercase mb-0">{{ isPlayingAudio ? 'Playing...' : 'Play Audio' }}</p>
        </div>
      </div>

      <!-- Images Grid -->
      <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0;" *ngIf="detail.images && detail.images.length > 0">
        <div class="card-body p-4">
          <h5 class="fw-bold mb-3"><i class="fas fa-images me-2 text-primary"></i>Attached Photos</h5>
          
          <div class="row g-3">
            <div class="col-6 col-md-4" *ngFor="let img of detail.images">
              <div class="ratio ratio-1x1 border rounded-3 overflow-hidden shadow-sm image-thumbnail" 
                   [style.background-image]="'url(' + (img.img_url || img.url || img) + ')'"
                   style="background-size: cover; background-position: center; cursor: pointer; background-color: #f8f9fa;"
                   (click)="openImageModal(img.img_url || img.url || img)">
                <div class="overlay d-flex justify-content-center align-items-center">
                  <i class="fas fa-search-plus text-white fs-3"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>

<!-- Fullscreen Image Modal -->
<div class="modal-backdrop fade show" *ngIf="selectedImage" (click)="closeImageModal()" style="z-index: 1040;"></div>
<div class="modal fade show d-block" tabindex="-1" *ngIf="selectedImage" style="z-index: 1050;">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-header border-0 pb-0 justify-content-end">
        <button type="button" class="btn-close btn-close-white shadow-none fs-4" (click)="closeImageModal()"></button>
      </div>
      <div class="modal-body text-center p-0 pt-2 pb-4">
        <img [src]="selectedImage" class="img-fluid rounded shadow-lg" style="max-height: 80vh; border: 3px solid white;">
      </div>
    </div>
  </div>
</div>
